import {getRangeTypesData, getEmulsionDosingTypes} from "../../helpers/values/reportValues";
import {WorkType} from "../work-type/work-type";

const emulsionDosingTypes = getEmulsionDosingTypes(0, 1, 0.1);

const rangeTypesData = getRangeTypesData(0, 20000, 100);

let workTypes = [];

WorkType().then(res => {
    workTypes = res?.data;
});

const sprinklingPlacesData = [
    {
        id: 1,
        value: 'Trasa główna',
    },
    {
        id: 2,
        value: 'Łącznica',
    },
    {
        id: 3,
        value: 'Droga poprzeczna',
    },
    {
        id: 4,
        value: 'Droga dojazdowa',
    },
    {
        id: 5,
        value: 'MOP'
    },
    {
        id: 6,
        value: 'Droga serwisowa'
    },
    {
        id: 7,
        value: 'Droga technologiczna'
    },
    {
        id: 8,
        value: 'Pobocze'
    }
];

const layerTypesData = [
    {
        id: 1,
        value: 'Tłuczeń'
    },
    {
        id: 2,
        value: 'Warstwa podbudowy bitumicznej (I)'
    },
    {
        id: 3,
        value: 'Warstwa podbudowy bitumicznej (II)'
    },
    {
        id: 4,
        value: 'Warstwa wiążąca'
    },
    {
        id: 5,
        value: 'Skropienie powtórne'
    },
    {
        id: 6,
        value: 'Krawędź'
    },
    {
        id: 7,
        value: 'Ściek'
    },
    {
        id: 8,
        value: 'SMA'
    },
    {
        id: 9,
        value: 'Brak skropienia'
    }
];

const sideOfRoadData = [
    {
        id: 1,
        value: 'Rondo'
    },
    {
        id: 2,
        value: 'Lewa'
    },
    {
        id: 3,
        value: 'Prawa'
    },
    {
        id: 4,
        value: 'Zjazd'
    }
]

export {emulsionDosingTypes, rangeTypesData, workTypes, sprinklingPlacesData, layerTypesData, sideOfRoadData}
